import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { BillRunDetail } from '../components/bills/BillRunDetail';
import { useBackTarget } from '../utils/backTarget';

export function BillDetailPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  // Job 91: opened from Bulk Bill Run, the breadcrumb goes back to that board
  // (same filters, view and page) rather than to the Bills list.
  const back = useBackTarget({ label: 'Bills', to: '/bill-validation/bills' });

  return (
    <div className="w-full py-6 px-4 sm:px-6 lg:px-8">
      {/* ── Breadcrumb ─────────────────────────────────────────────────────── */}
      <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-5">
        <button
          data-testid="bill-detail-back"
          onClick={() => navigate(back.to)}
          className="hover:text-primary transition-colors"
        >
          {back.label}
        </button>
        <ChevronRight className="h-3.5 w-3.5" />
        <span className="font-mono font-medium text-gray-900">Bill Run</span>
      </nav>

      <BillRunDetail
        billId={id ?? ''}
        // Switching bills keeps the way back.
        onBillIdChange={(nid) => navigate(`/bill-validation/bills/${nid}`, { state: location.state })}
      />
    </div>
  );
}
